import { BasePageState } from '../shared/BasePageState';

export class GeneralErrorState extends BasePageState<null> {}
